import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: LocalizedString = {
	[Locale.cs]: "/projekty",
	[Locale.en]: "/projects",
	[Locale.sk]: "/projekty",
};

export function getEuProjektDetailPath(tenant: Tenant, slug: string): string {
	const basePath = getPathInLocale(tenant.locale, pathMap);
	return `${basePath}/${slug}`;
}
